import React from 'react';
import PropTypes from 'prop-types';

import { CartStore } from '../../../stores/CartStore';
import styles from './DeletedProductCard.css';
import { InfoModal } from '../../../common/info-modal';
import { constants } from '../../../config';

const IProduct = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  serviceProduct: PropTypes.object,
});

const IPropTypes = {
  className: PropTypes.string,
  product: IProduct.isRequired,
  hasService: PropTypes.bool,
};

const defaultProps = {
  className: '',
  hasService: false,
};

const DeletedProductCard = props => (
  <div className={[styles.container, props.className].join(' ')}>
    <div className={styles.nameContainer}>
      <p className={styles.subtitle}>
        1 elemento borrado del carrito
      </p>
      <p className={styles.name}>
        {props.product.name}
      </p>
      {
        !!props.product.serviceProduct &&
        props.hasService &&
        <InfoModal
          id="servicio-instalación-covid"
          type="component"
          showConfirm={false}
          textCancel="Cerrar"
          showModal={constants.activeCovid}
        >
          <p className={styles.subtitle}>
            {props.product.textsService[1]}
          </p>
        </InfoModal>
      }
      {
        !!props.product.serviceProduct &&
        !props.hasService &&
        <p className={styles.subtitle}>
          {props.product.textsService[2]}
        </p>
      }
    </div>
    <div className={styles.actionContainer}>
      <button
        className={styles.undoButton}
        onClick={() => CartStore.undoDelete(props.product.id, props.hasService)}
      >
        Deshacer
      </button>
    </div>
  </div>
);

DeletedProductCard.propTypes = IPropTypes;
DeletedProductCard.defaultProps = defaultProps;

export { DeletedProductCard };



// WEBPACK FOOTER //
// ./src/pages/cart/deleted-product-card/DeletedProductCard.jsx